$(document).ready(function() {
  $('.faq-accordion > dd').hide();
  $('.faq-accordion > dt > button').attr('aria-expanded', false);

  $('.faq-accordion > dt > button').on('click', function() {
      const $this = $(this);
      const $icon = $this.find('.icon');

      const isOpen = $this.attr('aria-expanded') === 'true';
      $this.attr('aria-expanded', !isOpen);
      $this.parent().next().slideToggle(function() {
          $icon.toggleClass('icon--active');
      });
  });

  $('.faq-accordion > dt > button').on('keydown', function(event) {
      if (event.keyCode === 13) {
          $(this).click();
      }
  });

  // Back In Stock Popup
  // Remember the iframe only appears after an interaction to init the the popup
  // Iframe does share the same origin
  const bisObserver = new MutationObserver(function(muts, obs) {
    const iframe = $('#BIS_frame');
    
    if (iframe.length) {
      const iframeBody = iframe.contents().find('body').first();
      const popup = iframeBody.find('#BISModal').first();
      const popupContent = popup.find('.modal-content').first();
      const popupClose = popup.find('.close').first();

      // Re-usable function(s)
      const closePopup = function() { // Re-usable close function
        popupClose.trigger('click');
      }

      // Handle click events
      iframeBody.on('click', function(event) {
        const nonClickables = $(event.target).closest(popupContent).length;

        if (nonClickables === 0) {
          closePopup();
        }
      });

      // Handle esc key events
      // Remember modal does not trap the keyboard so target both the doc and the el
      $(document).add(iframeBody).on('keyup', function (event) {
        if (event.keyCode === 27 && iframe.is(':visible')) {
          closePopup();
        }
      });
    }
  });

  bisObserver.observe(document.body, {
    childList: true,
    subtree: false // BIS iframe is placed as a child of the body, no need for subtree
  });
});
